import t from 'tcomb';
import { template } from './template';
import isEmpty from 'lodash/lang/isEmpty';

const Http_Method = t.enums.of(['get', 'post'], 'Http_Method');
const Http_Data_Type = t.enums.of(['json'], 'Http_Data_Type');
const Http_Params = t.dict(t.String, t.Function, 'Http_Params');

const Http = t.struct({
  async: t.Boolean,
  url: t.String,
  method: Http_Method,
  data_type: t.maybe(Http_Data_Type),
  url_params: t.maybe(Http_Params),
  form_params: t.maybe(Http_Params),
}, 'Http');

Http.parse_response = function(response) {
  try {
    return response ?
      JSON.parse(response) :
      null;
  }
  catch (e) {
    return null;
  }
};

Http.checked_error = function(xhr, text_status, thrown_error) {
  var json = Http.parse_response(xhr.responseText);
  if (json && !t.Nil.is(json.error)) {
    const error = new Error(json.error);
    error.name = json.error;
    error.response_error = json;
    return error;
  }
  return Http.unexpected_error(xhr, text_status, thrown_error);
};

Http.unexpected_error = function(xhr, text_status, thrown_error) {
  if (text_status === 'timeout') {
    xhr.abort();
    const timeoutError = new Error('timeout');
    timeoutError.name = 'timeout';
    return timeoutError;
  }
  const error = new Error(thrown_error);
  error.name = thrown_error;
  return error;
};

Http.to_error = function(args, xhr, text_status, thrown_error) {
  var err = text_status === "error" && xhr ?
    Http.checked_error(xhr, text_status, thrown_error) :
    Http.unexpected_error(xhr, text_status, thrown_error);
  err.request = this;
  err.args = args;
  err.xhr = xhr;
  return err;
};

Http.prototype.to_func = function() {
  var self = this;
  return function(args: t.Object, callback: t.Function) {

    var url_args = {};
    var form_args = {};
    var param;
    var arg;

    for (param in self.url_params) {
      arg = args[param];
      // controllo il tipo dei parametri
      t.assert(self.url_params[param].is(arg));
      // converto gli argomenti in stringa
      /*
          arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
          // i parametri nell'url vanno encondati
          url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
      */
      if (arg) {
        arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
        // i parametri nell'url vanno encondati
        url_args[encodeURIComponent(param)] = encodeURIComponent(arg);
      }
      else {
        url_args[encodeURIComponent(param)] = "";
      }
    }
    for (param in self.form_params) {
      arg = args[param];
      // controllo il tipo delle form
      t.assert(self.form_params[param].is(arg));
      // converto gli argomenti in stringa
      arg = typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
      form_args[param] = arg;
    }

    // fix IE bug: se method = "post" e non c'è nessun parametro nella form, IE manda una chiamata in GET
    if (self.method === 'post' && isEmpty(form_args)) {
      form_args["__noemptybody__"] = "";
    }

    // converto la configurazione dell'api in una configurazione del metodo ajax() di jQuery
    var url = template(self.url)(url_args);
    var config = {
      async: self.async,
      cache: false,
      type: self.method,
      dataType: self.data_type || 'json',
      url: url,
      data: form_args
    };

    var request = $.ajax(config);
    if (callback) {
      request.then(function(response) {
        callback(null, response);
      }, function(xhr, text_status, thrown_error) {
        callback(Http.to_error(args, xhr, text_status, thrown_error));
      });
      return null;
    }
    else {
      return request.then(function(response) {
        return response;
      }, function(xhr, text_status, thrown_error) {
        return Http.to_error(args, xhr, text_status, thrown_error);
      }).promise();
    }

  };
};

export default function http(config) {
  return new Http(config).to_func();
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/http.js
 **/